import { render, staticRenderFns } from "./EmailBlock.vue?vue&type=template&id=b44a52da&"
import script from "./EmailBlock.vue?vue&type=script&lang=js&"
export * from "./EmailBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports